export default "skymp5-front/43f55e65b97c0f3da29c009f88fd7b03.gif";